import {UserManager as UserManagerOidc, WebStorageStateStore} from 'oidc-client-ts';

const UserManager = new UserManagerOidc({
  authority: window.appConfig.APP_AUTHORITY,
  client_id: window.appConfig.APP_CLIENT_ID,
  scope: window.appConfig.APP_SCOPE,
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  accessTokenExpiringNotificationTimeInSeconds: 10,
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({store: window.localStorage})
});

const hasAuthParams = (location = window.location): boolean => {
  if (window.location.pathname.includes('dropbox')) {
    return false;
  }
  if (window.location.pathname.includes('twitter')) {
    return false;
  }
  if (window.location.pathname.includes('google')) {
    return false;
  }

  // response_mode: query
  let searchParams = new URLSearchParams(location.search);
  if ((searchParams.get('code') || searchParams.get('error')) && searchParams.get('state')) {
    return true;
  }

  // response_mode: fragment
  searchParams = new URLSearchParams(location.hash.replace('#', '?'));
  if ((searchParams.get('code') || searchParams.get('error')) && searchParams.get('state')) {
    return true;
  }

  return false;
};

export {UserManager, hasAuthParams};
